/**
 * Application constants
 */

export const APP_NAME = "3PM Escrow";
export const APP_NAME_FULL = "3PM Escrow - Project Management";
export const APP_DESCRIPTION = "3PM Escrow - Project Management System";
